'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _draftJs = require('draft-js');

exports.default = function (editorState) {
    var currentSelection = editorState.getSelection();
    var selection = currentSelection.set('hasFocus', false);
    return _draftJs.EditorState.acceptSelection(editorState, selection);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/customRichUtils/forceBlur.js
// module id = 1714
// module chunks = 0